import {
  AffinitiesService,
  type AffinityTid
} from '@myredhat/elements/lib/affinitiesService.js';
import { AFFINITY_CATEGORY_MAP, type CategoryName } from './types.js';

const affinitiesService = new AffinitiesService();

/**
 * Helper function to get typed keys from an Object.entries
 */
const getObjectEntries = <T extends object>(obj: T) => {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
};

// Takes in the response from Adobe Target that has
// our list of affinities by taxonomy id, and outputs
// an array of category objects.
export async function getPersonalizedCategories() {
  const affinities = await affinitiesService.getTopicAffinities() as (keyof typeof AFFINITY_CATEGORY_MAP)[];
  const categoryMap = new Set<CategoryName>();
  for (const affinity of affinities) {
    const category = AFFINITY_CATEGORY_MAP[affinity];
    if (category) {
      categoryMap.add(category);
    }
  }
  return [...categoryMap.values()];
}

export function getCategoriesFromAffinities(affinities: string): CategoryName[] {
  const { affinityDict } = affinitiesService;
  if (!affinityDict) {
    return [];
  }
  const affinityArry = affinities.split(',') as AffinityTid[];
  const affinityNames = affinityArry.map(tid => affinityDict.topics[tid]['en']);
  const categories: Set<CategoryName> = new Set();
  for (const a of affinityNames) {
    const val = AFFINITY_CATEGORY_MAP[a];
    if (!val) { continue; }
    categories.add(val);
  }
  return Array.from(categories.values());
}

export function devtoolsDataSet(): [AffinityTid, string][] {
  const { affinityDict } = affinitiesService;
  if (!affinityDict?.topics) {
    return [];
  }
  const ret: [AffinityTid, string][] = [];
  for (const [tid, item] of getObjectEntries(affinityDict.topics)) {
    const category = AFFINITY_CATEGORY_MAP[item.en];
    ret.push([tid, `${item.en} ${category ? `(${category})` : ''}`]);
  }
  return ret;
}
